import { gql } from 'urql';
import { PRODUCT } from '../client';
import { GMarkItemsAsEcomBulkMutation } from '../types/generated';

export const MARK_ITEMS_AS_ECOM_BULK = gql<GMarkItemsAsEcomBulkMutation>`
  mutation ${PRODUCT}MarkItemsAsEcomBulk($input: MarkItemsAsEcomBulkMutationInput!) {
    markItemsAsEcomBulk(input: $input) {
      success
      userErrors {
        message
        path
      }
    }
  }
`;
